function Footer() {
    return (
      <footer>
        <ul className="list-group list-group-horizontal m-3 justify-content-center">
          <li className="list-group-item"><a href="https://github.com/CommieDog">GitHub</a></li>
          <li className="list-group-item"><a href="https://www.linkedin.com/in/john-netzel-481112129/">LinkedIn</a></li>
          <li className="list-group-item"><a href="https://stackoverflow.com/users/18535429/john-netzel">Stack Overflow</a></li>
        </ul>
        <p>Copyright 2022 by John Netzel. All rights reserved.</p>
        <p>Licensed under the terms of the MIT License.</p>
      </footer>
    );
  }
  
  export default Footer;